import { Action } from 'redux';
import { select, put } from 'redux-saga/effects';
import { BasketActionTypes, BasketActions } from '../';
import { ErrorAction, AppState } from 'store';
import { api } from 'repositories/api';
import { userHelper, productHelper, analyticsHelper, errorToBasketErrorModel } from 'helpers';
import { ProductTypes } from 'models/Basket';
import { BasketSagaReturnType } from 'store/sagaHelpers';

export interface AddProductAction extends Action<BasketActionTypes.ADD_PRODUCT> {
    code: string;
    quantity: number;
    sofaglideParentCode?: string;
}

export interface AddProductActionStart extends Action<BasketActionTypes.ADD_PRODUCT_START> {
}

export interface AddProductActionSuccess extends Action<BasketActionTypes.ADD_PRODUCT_SUCCESS> {
}

export interface AddProductActionError extends ErrorAction<BasketActionTypes.ADD_PRODUCT_ERROR> {
}

export function* addProductSaga({ code, quantity, sofaglideParentCode }: AddProductAction): BasketSagaReturnType {
    yield put<BasketActions>({
        type: BasketActionTypes.ADD_PRODUCT_START
    });

    try {
        const state: AppState = yield select();
        const username = userHelper.getCurrentUserName();
        const basketId = state.basketState.basket!.guid;

        yield api.hybris.addProduct(username, basketId, code, quantity, sofaglideParentCode);

        sendAnalytics(code, quantity, Boolean(sofaglideParentCode));

        yield put<BasketActions>({
            type: BasketActionTypes.ADD_PRODUCT_SUCCESS
        });

        return true;
    } catch (error) {
        yield put<BasketActions>({
            type: BasketActionTypes.ADD_PRODUCT_ERROR,
            error: errorToBasketErrorModel(error, 'addProductSaga')
        });

        return false;
    }
}

function sendAnalytics(code: string, addedQuantity: number, isSofaglide: boolean): void {
    analyticsHelper.withLogging(() => {
        // adding sofaglides is processing in addUpsell and updateSofaglide sagas
        // it's because updateSofaglide has to remove and then to add sofaglides for each update operation
        // and we do not want to send event about adding sofaglide twice (in updateSofaglide and in addProduct sagas)
        if (!isSofaglide) {
            const productType = productHelper.getProductTypeByCode(code);

            if (productType === ProductTypes.FabricCareKit
                || productType === ProductTypes.LeatherCareKit
                || productType === ProductTypes.SofaRescue
                || productType === ProductTypes.Donation
                || productType === ProductTypes.Sofashield
            ) {
                api.google.addAdditionalProduct(productType, code, addedQuantity);
            }
        }
    }, 'addProductSaga');
}